import React, { useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import mailSymbol from "../../../Assets/mailSymbol.png";
import { FaBars } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import Button from "../../Button/Button";
import ImageComponent from "../../Image/ImageComponent";

const LandingPageSideBar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <nav className="bg-white shadow-md fixed w-full z-50">
      <div className="bg-[#f8f5f0] flex justify-start items-center gap-2 px-4 py-2">
        <div>
          <ImageComponent src={mailSymbol} alt="mailSymbol" />
        </div>
        <div>tim@yourtreeguy.com</div>
      </div>
      <div className=" hidden md:flex justify-between items-center">
        <div className="flex flex-col w-full">
          <div className="flex justify-between py-2 px-4 items-center">
            <div className="text-lg font-bold items-center">
              TAHOE FORESTRY CONSULTING LLC
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-6 items-center">
              <a href="#Home" className="text-[#0b3d2c] hover:text-green-700">
                Home
              </a>
              <a
                href="#How It Works"
                className="text-[#0b3d2c] hover:text-green-700"
              >
                How It Works
              </a>
              <a
                href="#Cost of Tree Work"
                className="text-[#0b3d2c] hover:text-green-700"
              >
                Cost of Tree Work
              </a>
              <a
                href="#Connect with an Arborist"
                className="text-[#0b3d2c] hover:text-green-700"
              >
                Connect with an Arborist
              </a>
              <a
                href="#Contact Us"
                className="text-[#0b3d2c] hover:text-green-700"
              >
                Contact Us
              </a>
            </div>
            <Button
              label={"Get Started"}
              className="bg-[#0b3d2c] text-white py-2 rounded-full px-10"
            />
          </div>
        </div>
      </div>
      {/* Mobile Menu Toggle */}
      <div className=" md:hidden flex justify-end p-2">
        <button
          className=" text-gray-600 focus:outline-none"
          onClick={toggleDrawer}
        >
          <FaBars size={24} />
        </button>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        open={isDrawerOpen}
        onClose={toggleDrawer}
        direction="left"
        className="w-64"
      >
        <div className="p-4">
          <div className="flex justify-between">
            <h2 className="text-lg font-extrabold mb-4 text-[#0b3d2c]">
              TAHOE FORESTRY CONSULTING LLC
            </h2>
            <IoClose
              onClick={toggleDrawer}
              className="cursor-pointer text-[30px]"
            />
          </div>
          <ul className="space-y-4">
            <li>
              <a
                href="#Home"
                className="text-gray-600 hover:text-green-700"
                onClick={toggleDrawer}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#How It Works"
                className="text-gray-600 hover:text-green-700"
                onClick={toggleDrawer}
              >
                How It Works
              </a>
            </li>
            <li>
              <a
                href="#Cost of Tree Work"
                className="text-gray-600 hover:text-green-700"
                onClick={toggleDrawer}
              >
                Cost of Tree Work
              </a>
            </li>
            <li>
              <a
                href="#Connect with an Arborist"
                className="text-gray-600 hover:text-green-700"
                onClick={toggleDrawer}
              >
                Connect with an Arborist
              </a>
            </li>
            <li>
              <a
                href="#Contact Us"
                className="text-gray-600 hover:text-green-700"
                onClick={toggleDrawer}
              >
                Contact Us
              </a>
            </li>
          </ul>
          <Button
            label={"Get Started"}
            className="bg-[#0b3d2c] text-white py-2 rounded-full px-10 mt-4"
            onClick={toggleDrawer}
          />
        </div>
      </Drawer>
    </nav>
  );
};

export default LandingPageSideBar;
